<template>
  <div class="layout-padding">
    <v-snackbar v-model="snackbarShow" :color="snackbarType">
      <b>{{snackbarText}}</b>
      <v-btn text @click="snackbarShow = false">Close</v-btn>
    </v-snackbar>

    <StatusPopup
      v-if="popupShow"
      :status="this.status"
      :email="this.email"
      :showEmail="this.showEmail"
      @change="popupShow = false;"
    />

    <FinalizePopup v-if="finalizePopupShow" @change="handlePopupInput" />

    <div>
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step :complete="currentStep > 1" step="1">Tickets</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="currentStep > 2" step="2">Attendees</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="currentStep > 3" step="3">Payment</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <Tickets
              v-if="currentStep === 1"
              :disableDiscountCodeInput="disableDiscountCodeInput"
              @change="checkDiscountCode"
            />
          </v-stepper-content>
          <v-stepper-content step="2">
            <Attendees v-if="currentStep === 2" @change="handleAttendeesInput" />
          </v-stepper-content>
          <v-stepper-content step="3">
            <template v-if="currentStep === 3">
              <template v-if="klixTrid === null">
                <template
                  v-if="(!showPayments && isCompany) || (!showPayments && !this.paymentCardIsShown() && !isCompany)"
                >
                  <ClientData />
                </template>
                <template v-else>
                  <Payment @change="handlePaymentInput" />
                </template>
              </template>

              <template v-if="klixTrid != null">
                <klix-checkout v-pre></klix-checkout>
              </template>
            </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import FinalizePopup from "@/components/FinalizePopup";
import Attendees from "@/components/Attendees";
import Payment from "@/components/Payment";
import ClientData from "@/components/ClientData";
import Tickets from "@/components/Tickets";
import BadPage from "@/components/BadPage";
import StatusPopup from "@/components/StatusPopup";
import VueMarkdown from "vue-markdown";

import helperMethods from "../mixins/helperMethods";
import storeData from "../mixins/storeData";
import totalPrices from "../mixins/totalPrices";
import allRules from "../mixins/allRules";
import paymentOptions from "../mixins/paymentOptions";
import constants from '@/constants';

export default {
  components: {
    FinalizePopup,
    Attendees,
    Payment,
    ClientData,
    Tickets,
    BadPage,
    StatusPopup,
    VueMarkdown
  },
  mixins: [helperMethods, storeData, totalPrices, allRules, paymentOptions],
  mounted() {},
  data() {
    return {
      tenantId: null,
      disableDiscountCodeInput: false,
      openSpeakersModal: false,
      valid: true,
      snackbarShow: false,
      snackbarType: "error",
      snackbarText: "Error message",
      popupShow: false,
      status: "failure",
      incorrectUrl: false,
      productCounts: {},
      orderId: null,
      finalizePopupShow: false,
      finishButtonShow: true,
      klixTrid: null,
      showEmail: true
    };
  },
  methods: {
    onCaptchaVerified: function(recaptchaToken) {
      const self = this;
      self.finishButtonShow = true;
    },

    buildWidget() {
      let checkoutWidget = document.querySelector("#my-checkout-widget");

      this.productCounts = this.tickets
        .map(({ productType }) => productType)
        .reduce((productTypes, productType) => {
          const count = productTypes[productType] || 0;
          productTypes[productType] = count + 1;
          return productTypes;
        }, {});

      for (var key in this.productCounts) {
        let value = this.productCounts[key];

        var product = this.products.find(function(element) {
          return element.productType === key;
        });

        checkoutWidget.addOrderItem({
          amount: product.price,
          currency: "EUR",
          label: product.productLabel,
          count: value,
          unit: "PIECE",
          taxRate: 0.21
        });
      }
      checkoutWidget.setOrderId(this.orderId);

      checkoutWidget.init();
    },

    submit() {
      this.completeRegistration();
    },
    submitKlix() {
      this.completeRegistrationKlix();
    },
    checkDiscountCode() {
      this.$http
        .post(constants.restBaseURL + "/public/products", {
          tenantId: this.tenantId,
          discountCode: this.discountCode
        })
        .then(response => {
          let responseProductsClone = _.cloneDeep(response.data.products);
          let productsClone = _.cloneDeep(this.products);

          responseProductsClone.forEach(p => {
            const product = this.getProductByType(p.productType, productsClone);
            if (product) {
              product.price = p.price;
            } else {
              productsClone.push(p);
            }
          });

          this.products = productsClone;
          this.$gtm.trackEvent({
            category: "discount-code-enter",
            action: "success",
            label: this.discountCode,
            noninteraction: false
          });
          this.buildProductGroups();
          this.refreshTickets();
          this.disableDiscountCodeInput = true;
          this.showSuccess("Success! Discount is applied to product prices");
        })
        .catch(error => {
          if (
            error.response !== undefined &&
            error.response.data.error &&
            error.response.data.error.description
          ) {
            this.showError(error.response.data.error.description);
          } else if (error.response.status === 400) {
            this.showError("Discount Code is not valid or expired.");
          } else {
            this.showError("Something went wrong. Please contact us.");
          }
          this.$gtm.trackEvent({
            category: "discount-code-enter",
            action: "failure",
            label: this.discountCode,
            noninteraction: false
          });
        });
    },
    buildProductGroups() {
      let productsClone = _.cloneDeep(this.products);

      let newSingleProducts = this._.filter(productsClone, p => !p.group);

      this.groupProducts = [];
      let groupProductsClone = _.cloneDeep(this.groupProducts);

      const groupedProducts = this._.chain(productsClone)
        .filter(p => p.group)
        .groupBy("group")
        .value();

      this._.keys(groupedProducts).forEach(key => {
        const firstProduct = groupedProducts[key][0];
        groupProductsClone.push({
          productLabel: key,
          productDescription: firstProduct.groupDescription,
          price: firstProduct.price,
          priority: firstProduct.priority,
          vatRate: firstProduct.vatRate,
          products: groupedProducts[key]
        });
      });

      this.products = productsClone;
      this.singleProducts = newSingleProducts;
      this.groupProducts = groupProductsClone;
    },
    getProductByType(productType, productsClone) {
      return productsClone.find(p => p.productType === productType);
    },
    refreshTickets() {
      let ticketsClone = _.cloneDeep(this.tickets);

      ticketsClone.forEach(t => {
        if (t.availableProducts) {
          this.refreshTicketAvailableProducts(t);
        }
        const product = this.productByType(t.productType);
        t.price = product.price;
      });

      this.tickets = ticketsClone;
    },
    refreshTicketAvailableProducts(ticket) {
      ticket.availableProducts.forEach(p => {
        let product = this.productByType(p.productType);
        p.price = product.price;
      });

      let groupProduct = this._.find(this.groupProducts, {
        productLabel: ticket.availableProducts[0].group
      });
      ticket.availableProducts = groupProduct.products;
    },
    completeRegistration() {
      const body = {
        tenantId: this.tenantId,
        client: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          country: this.country
        },
        tickets: this.tickets,
        agreeTermsAndConditions: this.agreeTermsAndConditions,
        agreeDataTerms: this.agreeDataTerms,
        agreeMailingList: this.agreeMailingList
      };
      if (this.isCompany) {
        body.company = {
          companyName: this.companyName,
          address: this.companyAddress,
          registrationNumber: this.registrationNumber
        };

        if (this.vatNumber) {
          body.company.vatNumber = this.vatNumber;
        }

        if (this.iban) {
          body.company.iban = this.iban;

          if (this.bank) {
            body.company.bank = this.bank;
          }
          if (this.bic) {
            body.company.bic = this.bic;
          }
        }
      } else {
        body.client.address = this.address;
      }

      if (this.discountCode) {
        body.discountCode = this.discountCode;
      }
      this.$http
        .post(constants.restBaseURL + "/public/tickets/buy", body)
        .then(response => {
          this.$gtm.trackEvent({
            category: "tickets-invoice-registration",
            action: "success",
            noninteraction: true
          });
          this.status = "success";
          this.showPopup();
          this.resetData();
          this.refreshProducts();
        })
        .catch(error => {
          this.$gtm.trackEvent({
            category: "tickets-invoice-registration",
            action: "failure",
            noninteraction: true
          });
          if (
            error.response !== undefined &&
            error.response.data.error &&
            error.response.data.error.description
          ) {
            this.showError(error.response.data.error.description);
          } else {
            this.showError("Something went wrong. Please contact us.");
          }
        });
    },
    completeRegistrationKlix() {
      let body = "";
      if (this.isCompany) {
        body = {
          tenantId: this.tenantId,
          client: {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
            country: this.country
          },
          tickets: this.tickets,
          agreeTermsAndConditions: this.agreeTermsAndConditions,
          agreeDataTerms: this.agreeDataTerms,
          agreeMailingList: this.agreeMailingList
        };
      } else {
        if (this.tickets.length === 1) {
          body = {
            tenantId: this.tenantId,
            client: {
              firstName: this.tickets[0].firstName,
              lastName: this.tickets[0].lastName,
              email: this.tickets[0].email,
              phone: "0000000000",
              country: "KLIX"
            },
            tickets: this.tickets,
            agreeTermsAndConditions: true,
            agreeDataTerms: true,
            agreeMailingList: true
          };
        } else {
          body = {
            tenantId: this.tenantId,
            client: {
              firstName: "KLIX",
              lastName: "KLIX",
              email: "KLIX@klix.com",
              phone: "0000000000",
              country: "KLIX"
            },
            tickets: this.tickets,
            agreeTermsAndConditions: true,
            agreeDataTerms: true,
            agreeMailingList: true
          };
        }
      }
      if (this.isCompany) {
        body.company = {
          companyName: this.companyName,
          address: this.companyAddress,
          registrationNumber: this.registrationNumber
        };

        if (this.vatNumber) {
          body.company.vatNumber = this.vatNumber;
        }

        if (this.iban) {
          body.company.iban = this.iban;

          if (this.bank) {
            body.company.bank = this.bank;
          }
          if (this.bic) {
            body.company.bic = this.bic;
          }
        }
      } else {
        body.client.address = "KLIX";
      }

      if (this.discountCode) {
        body.discountCode = this.discountCode;
      }
      this.$http
        .post(constants.restBaseURL + "/public/tickets/klix-buy", body)
        .then(response => {
          this.$gtm.trackEvent({
            category: "tickets-card-registration",
            action: "success",
            noninteraction: true
          });
          this.orderId = response.data.orderId;
          this.buildWidget();
        })
        .catch(error => {
          this.$gtm.trackEvent({
            category: "tickets-card-registration",
            action: "failure",
            noninteraction: true
          });
          if (
            error.response !== undefined &&
            error.response.data.error &&
            error.response.data.error.description
          ) {
            this.showError(error.response.data.error.description);
          } else {
            this.showError("Something went wrong. Please contact us.");
          }
        });
    },
    showError(message) {
      this.snackbarType = "error";
      this.snackbarText = message;
      this.snackbarShow = true;
    },
    showSuccess(message) {
      this.snackbarType = "success";
      this.snackbarText = message;
      this.snackbarShow = true;
    },
    showPopup() {
      this.popupShow = true;
    },
    productsToOptions(products) {
      return this._.map(products, p => ({
        label: p.productLabel,
        value: p.productType
      }));
    },
    refreshProducts() {
      this.$http
        .get(constants.restBaseURL + "/public/products?tenantId=" + this.tenantId)
        .then(
          response => {
            this.products = response.data.products;
            this.buildProductGroups();
          },
          error => {
            if (
              error.response !== undefined &&
              error.response.data.error &&
              error.response.data.error.description
            ) {
              this.showError(error.response.data.error.description);
            } else {
              this.showError("Something went wrong. Please contact us.");
            }
          }
        );
    },
    refreshTemplates() {
      this.$http
        .get(constants.restBaseURL + "/public/templates?tenantId=" + this.tenantId)
        .then(
          response => {
            this.templates = response.data.templates;
          },
          error => {
            if (
              error.response !== undefined &&
              error.response.data.error &&
              error.response.data.error.description
            ) {
              this.showError(error.response.data.error.description);
            } else {
              this.showError("Something went wrong. Please contact us.");
            }
          }
        );
    },
    refreshProperties() {
      this.$http
        .get(constants.restBaseURL + "/public/properties?tenantId=" + this.tenantId)
        .then(
          response => {
            this.properties = response.data.properties;
          },
          error => {
            if (
              error.response !== undefined &&
              error.response.data.error &&
              error.response.data.error.description
            ) {
              this.showError(error.response.data.error.description);
            } else {
              this.showError("Something went wrong. Please contact us.");
            }
          }
        );
    },
    handlePaymentInput(update) {
      let orderKlix = update.orderKlix;
      let finalizePopupShow = update.finalizePopupShow;
      if (orderKlix) {
        this.submitKlix();
      }
      if (finalizePopupShow) {
        this.finalizePopupShow = finalizePopupShow;
      }
    },
    handleAttendeesInput(update) {
      let orderKlix = update.orderKlix;
      if (orderKlix) {
        this.submitKlix();
      }
    },
    handlePopupInput(update) {
      if (update.makeSubmit) {
        this.submit();
      }
      this.finalizePopupShow = update.finalizePopupShow;
    },
    klixCallbackListener() {
      const checkoutElement = document.querySelector("klix-checkout");
      checkoutElement.addEventListener("paymentCompleted", event => {
        if (event.detail["paymentSucceeded"]) {
          this.$gtm.trackEvent({
            category: "card-payment-status",
            action: "success",
            noninteraction: true
          });
          this.status = "success";
          this.showEmail = false;
          this.showPopup();
        } else {
          this.$gtm.trackEvent({
            category: "card-payment-status",
            action: "failure",
            noninteraction: true
          });
          this.status = "failure";
          this.showEmail = false;
          this.showPopup();
        }
      });
    },
    resetData() {
      this.isCompany = true;

      this.tickets = [];
      this.products = [];
      this.singleProducts = [];
      this.groupProducts = [];

      this.discountCode = "";
      this.disableDiscountCodeInput = false;
      this.currentStep = 1;
      this.showPayments = false;
      this.widgetShow = false;

      this.agreeDataTerms = false;
      this.agreeMailingList = false;
      this.agreeTermsAndConditions = false;
    }
  },

  beforeMount() {
    this.resetData();

    const urlParams = new URLSearchParams(window.location.search);
    let tenantId = document.getElementById("app").dataset.tenant;

    if (tenantId === undefined) {
      tenantId = urlParams.get("tenantId");
    }

    const paramKlix = urlParams.get("klix-trid");
    this.tenantId = tenantId;

    if (paramKlix != null) {
      this.klixTrid = paramKlix;
      this.currentStep = 3;
    }

    this.refreshProducts();
    this.refreshTemplates();
    this.refreshProperties();
  },
  mounted() {
    if (this.klixTrid != null) this.klixCallbackListener();
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
$main-color: #005a28;

.card-title {
  padding-bottom: 0;
}

#drift-widget-container {
  @media screen and (max-width: 800px) {
    display: none;
  }
}

.text-frontcon {
  color: #1782ab;
}
.bg-frontcon {
  background: #1782ab;
}

.v-list-item {
  padding: 0px;
}

.text-italic-grey {
  font-style: italic;
  color: grey;
}

.centered-vertically {
  display: flex;
  align-items: center;
}

@media (min-width: 1264px) {
  .layout-padding {
    padding: 3rem 4rem;
  }
}

@media (max-width: 1263px) and (min-width: 960px) {
  .layout-padding {
    padding: 2.5rem 3rem;
  }
}

@media (max-width: 959px) and (min-width: 600px) {
  .layout-padding {
    padding: 1.5rem 2rem;
  }
}

@media (max-width: 599px) {
  .layout-padding {
    padding: 1.5rem 0.5rem;
  }
}

.item-padding {
  padding: 8px 0px;
}

div.v-dialog__content {
  height: unset;
  margin-top: 10vh;
}
</style>
